import * as analytics from '@gitbook/app-analytics/client';
import { Icon } from '@gitbook/spine-icons';
import { DialogRoot, DialogTrigger, Heading } from '@gitbook/spine-react';

import { apiClient } from '../../../state';
import { SiteQuickActionCard, SiteQuickActionCardIcon } from '../../Site';
import { CreateTranslationDialog, type CreateTranslationDialogProps } from '../../Translations';
import type { SpaceCreationOnCreateSpace } from './types';

interface TranslationCardProps extends Pick<CreateTranslationDialogProps, 'defaultSpace'> {
    organizationId: string;
    onCreateSpace: SpaceCreationOnCreateSpace;
    defaultOpen?: boolean;
}

export function TranslationCard(props: TranslationCardProps) {
    const { organizationId, onCreateSpace, defaultOpen, defaultSpace } = props;

    return (
        <DialogRoot defaultOpen={defaultOpen}>
            <DialogTrigger>
                <SiteQuickActionCard>
                    <SiteQuickActionCardIcon>
                        <Icon.AITranslate />
                    </SiteQuickActionCardIcon>
                    <Heading>Translation</Heading>
                </SiteQuickActionCard>
            </DialogTrigger>
            <CreateTranslationDialog
                defaultSpace={defaultSpace}
                organizationId={organizationId}
                onSubmit={async ({ sourceSpace, translation }) => {
                    await onCreateSpace(async ({ collectionId }) => {
                        const title = `${sourceSpace.title} (${translation.language.toUpperCase()})`;
                        const { data: space } = await apiClient.spaces.createSpace(organizationId, {
                            // Keep translated spaces next to their source by default.
                            parent: collectionId ?? sourceSpace.parent ?? undefined,
                            title,
                            language: translation.language,
                            computedSource: {
                                type: 'builtin:translation',
                                props: {},
                                dependencies: {
                                    translation: {
                                        ref: {
                                            kind: 'translation',
                                            translation: translation.id,
                                        },
                                    },
                                },
                            },
                        });
                        analytics.logEvent(
                            analytics.createSpaceEvent(space, {
                                type: 'space_create',
                                source: 'translation',
                                title,
                            })
                        );
                        return space;
                    });
                }}
                intent="space_creation"
            />
        </DialogRoot>
    );
}
